import { useState, useEffect } from 'react'

import { useRouter } from 'next/router'

import { Locale, Footer } from '@/service/api/landingPage'
import { getLPTranslationData } from '@/utils/getLPTranslationData'

export const useFooterContainer = () => {
  const router = useRouter()
  const locale = (router.locale || 'pt-BR') as Locale

  const [footerData, setFooterData] = useState<Footer>(
    () =>
      getLPTranslationData({
        landingPage: 'software',
        container: 'footerContainer',
        locale,
      }) as Footer,
  )

  useEffect(() => {
    const translationsObject = getLPTranslationData({
      landingPage: 'software',
      container: 'footerContainer',
      locale,
    }) as Footer

    setFooterData(translationsObject)
  }, [locale])

  return {
    footerData,
  }
}
